import { Theme } from '@mui/material';

export const getFormLabelBoxWrapper = (theme: Theme, isOptionSelected: boolean, hasImage?: boolean) => {
	return {
		width: '100%',
		border: isOptionSelected ? '0.145rem solid' : '0.125rem solid',
		borderRadius: '0.5rem',
		borderColor: isOptionSelected ? theme.palette.text.interactive : theme.palette.neutrals?.primary,
		display: 'flex',
		justifyContent: hasImage ? 'start' : 'center',
		alignItems: 'center',
		gap: '0.938rem',
		padding: '1rem',
		position: 'relative',
		height: '100%',
	};
};

export const getSelectedOptionIconStyles = {
	height: '1.25rem',
	width: '1.25rem',
	maxWidth: '1.25rem',
	position: 'absolute',
	color: 'secondary.main',
	top: '0.3rem',
	right: '0.3rem',
};

export const getFormGroupStyles = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	gridTemplateColumns: '',
	flex: '',
	gap: '0.938rem',
};

export const imageStyles = {
	maxHeight: '7rem',
	width: '100%',
	maxWidth: '9rem',
	objectFit: 'cover',
};

export const getFormControlLabelStyles = {
	display: 'flex',
	width: '100%',
	margin: 0,
};
